/* Factories */
import { createSankeyDiagram } from "src/utils/layout/unstacked-layout/factories/createSankeyDiagram";
import { createHorizontalBoxplots } from "src/utils/layout/unstacked-layout/factories/createHorizontalBoxplots";
import { createTable } from "src/utils/layout/unstacked-layout/factories/createTable";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";

/* Interfaces */
import { ComponentProps } from "src/shared/interfaces/common/Layout";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";
import createLabel from "../../utils/createLabel";

export const createUnstackedLayout = (
  type: ChartType,
  outerIndex: number,
  data: BaseChartProps<
    TreatmentPatternsProps[],
    ChartType[][]
  >
): ComponentProps[] => {
  const label = createLabel(
    data,
    data.data[outerIndex].name,
    data.data[outerIndex].total,
    data.data[outerIndex].totalCohortSize,
    data.data[outerIndex].notLookedForCount,
    data.data[outerIndex].lookedForNoValueCount
  );

  const chartRenderer = () => {
    switch (type) {
      case ChartType.SANKEY:
        return createSankeyDiagram(
          outerIndex,
          label,
          data,
          data.data[outerIndex].name
        );
      case ChartType.TABLE:
        return createTable(outerIndex, data);
      case ChartType.BOX:
        return createHorizontalBoxplots(outerIndex, data);
      default:
        return [];
    }
  };

  return chartRenderer();
};
